import React, { useMemo, useState } from "react";

import {
    SectionEyebrow,
    Eyebrow,
    shell,
    serif,
    Title,
    CTA
} from "../components/CommonComponents";

export default function Overview({ course, images }) {
    return (
        <section id="overview" className="bg-white py-20 sm:py-24 lg:py-28">
            <div
                className={`${shell} grid gap-10 lg:grid-cols-[0.82fr_1.18fr] lg:items-center`}
            >
                <div className="relative min-h-[520px] overflow-hidden rounded-[4px_64px_4px_4px]">
                    <img
                        src={images.classroom}
                        alt="Students learning in a modern classroom"
                        className="absolute inset-0 h-full w-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#071A2F]/90 via-transparent to-transparent" />
                    <div className="absolute inset-x-7 bottom-7 text-white">
                        <span className="text-sm font-bold uppercase tracking-[0.14em] text-[#D5AD57]">
                            Inside the learning environment
                        </span>
                        <strong className={`${serif} mt-3 block text-3xl`}>
                            Ideas become decisions through active learning.
                        </strong>
                    </div>
                </div>
                <div>
                    <Eyebrow>Course overview</Eyebrow>
                    <Title>{course.short_title ? course.short_title : course.title} – Course Overview</Title>
                    {course.description.map((x, i) => (
                        <p key={i} className="mt-7 max-w-3xl text-md leading-9 text-[#65717D]">
                            {x}
                        </p>
                    ))}
                    {/* <div className="mt-9 grid gap-4 sm:grid-cols-3">
                        {[
                            "Management foundations",
                            "Applied decision-making",
                            "Professional readiness",
                        ].map((x, i) => (
                            <div
                                key={x}
                                className="border-t-2 border-[#D5AD57] bg-[#F7F2E8] p-5"
                            >
                                <span className="text-sm font-bold text-[#8B1E3F]">
                                    0{i + 1}
                                </span>
                                <strong className="mt-3 block text-base text-[#071A2F]">
                                    {x}
                                </strong>
                            </div>
                        ))}
                    </div> */}
                    <CTA bg="burgundy" title="View Curriculum" />
                </div>
            </div>
        </section>
    );
}
